import { type DriveFile } from '@/shared/DriveTypes';
import { StaticTreeMarkup } from '~/components/Tree/StaticTree';
import { indexName } from '~/utils/constants';
import { renderToString } from '~/utils/renderToString';
import { getId, macros } from '~/utils/utils';
import { Content } from './Content';

export const IndexPage = (props: {
  content: string;
  file: DriveFile;
  files: DriveFile[];
  wiki: DriveFile | undefined;
}) => {
  const { wiki, files, file } = props;
  // We pre-render the tree to avoid a delay showing it to the user, see TreeMacro.tsx for details
  const html = wiki
    ? renderToString(
        <StaticTreeMarkup
          files={files.filter((o) => o.parents?.[0] === getId(file) && o.name !== indexName)}
          wiki={wiki}
        />
      )
    : '';
  const content = props.content.replace(
    macros.global.files,
    /*html*/ `<div data-testid="tree" data-react="Tree"><div id="rendered-tree">${html}</div></div>`
  );
  return <Content content={content} />;
};

export default IndexPage;
